// eslint-disable-next-line import/prefer-default-export
export const COMPLIANCE_PATH = '/compliance';
